export const FETCH_FOLDER_TREE = 'folders/FETCH_FOLDER_TREE';
export const FETCH_FOLDER_TREE_SUCCESS = 'folders/FETCH_FOLDER_TREE_SUCCESS';
export const FETCH_FOLDER_TREE_ERROR = 'folders/FETCH_FOLDER_TREE_ERROR';

export const FETCH_CHILDREN = 'folders/FETCH_CHILDREN';
export const FETCH_CHILDREN_SUCCESS = 'folders/FETCH_CHILDREN_SUCCESS';
export const FETCH_CHILDREN_ERROR = 'folders/FETCH_CHILDREN_ERROR';

export const FETCH_FOLDER_DOCUMENT_COUNT = 'folders/FETCH_FOLDER_DOCUMENT_COUNT';
export const FETCH_FOLDER_DOCUMENT_COUNT_SUCCESS = 'folders/FETCH_FOLDER_DOCUMENT_COUNT_SUCCESS';
export const FETCH_FOLDER_DOCUMENT_COUNT_ERROR = 'folders/FETCH_FOLDER_DOCUMENT_COUNT_ERROR';

export const CREATE = 'folders/CREATE';
export const CREATE_SUCCESS = 'folders/CREATE_SUCCESS';
export const CREATE_ERROR = 'folders/CREATE_ERROR';

export const CREATE_MULTIPLE = 'folders/CREATE_MULTIPLE';
export const CREATE_MULTIPLE_SUCCESS = 'folders/CREATE_MULTIPLE_SUCCESS';
export const CREATE_MULTIPLE_ERROR = 'folders/CREATE_MULTIPLE_ERROR';

export const UPDATE = 'folders/UPDATE';
export const UPDATE_ERROR = 'folders/UPDATE_ERROR';
export const UPDATE_SUCCESS = 'folders/UPDATE_SUCCESS';

export const UPDATE_MULTIPLE = 'folders/UPDATE_MULTIPLE';
export const UPDATE_MULTIPLE_SUCCESS = 'folders/UPDATE_MULTIPLE_SUCCESS';
export const UPDATE_MULTIPLE_ERROR = 'folders/UPDATE_MULTIPLE_ERROR';

export const DELETE = 'folders/DELETE';
export const DELETE_SUCCESS = 'folders/DELETE_SUCCESS';
export const DELETE_ERROR = 'folders/DELETE_ERROR';

export const SET_ACTIVE_FOLDER_TREE = 'folders/SET_ACTIVE_FOLDER_TREE';

export const SET_FOLDER_TREE = 'folders/SET_FOLDER_TREE';

export const SET_ACTIVE_FOLDER_ID = 'folders/SET_ACTIVE_FOLDER_ID';

export const SET_EDITING_FOLDER_ID = 'folders/SET_EDITING_FOLDER_ID';

export const NAVIGATE_TO_FOLDER = 'folders/NAVIGATE_TO_FOLDER';
